import React, { Component } from "react";
import { Card, Grid, Menu, Table } from "semantic-ui-react";
import "../../node_modules/react-vis/dist/style.css";
import ChartUtils from "../charts/ChartUtils";
import "../css/home.css";
import Utils from "../util/Utils";
import { isMobile } from "react-device-detect";

export default class Financials extends Component {
  state = { activeItem: "Income" };

  handleItemClick = (e, { name }) => this.setState({ activeItem: name });

  render() {
    const { activeItem } = this.state;
    const { color } = "orange";

    let seg;

    const incomeYValues = this.props.stockValues.incomeStmtValues.slice(
      isMobile ? -3 : -5
    );
    const balnceYValues = this.props.stockValues.bsStmtValues.slice(
      isMobile ? -3 : -5
    );
    const cashflowYValues = this.props.stockValues.cfStmtValues.slice(
      isMobile ? -3 : -5
    );
    const quarterlyIncomeYValues =
      this.props.stockValues.quarterlyIncomeStmtValues.slice(
        isMobile ? -3 : -5
      );

    if (activeItem === "Income") {
      seg = (
        <Grid stackable centered>
          <Grid.Row columns={{ mobile: 1, tablet: 2, computer: 4 }}>
            <Grid.Column width={6} className="financials-card-column">
              <div>
                <Card fluid raised className="iv-section-card">
                  <Card.Content className="iv-section-body">
                    <Card.Header textAlign="center" className="iv-section-header">
                      <div className="iv-icon-box"><i className="bar chart icon" /></div>
                      <div>Yearly Income Statement Values</div>
                    </Card.Header>
                    <Card.Description>
                      <Table unstackable compact="very" celled size="small" className="iv-table">
                        <Table.Header>
                          <Table.Row>
                            <Table.HeaderCell className="iv-table-header">Year</Table.HeaderCell>
                            {Object.keys(incomeYValues).map((index) => (
                              <Table.HeaderCell className="iv-table-header" key={incomeYValues[index]["Revenue"].year}>
                                {incomeYValues[index]["Revenue"].year.substring(0, 4)}
                              </Table.HeaderCell>
                            ))}
                            <Table.HeaderCell className="iv-table-header">Trend</Table.HeaderCell>
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {Financials.returnRow("Income", incomeYValues, "Revenue", Utils.format_currency_short)}
                          {Financials.returnRow("", incomeYValues, "Net Income", Utils.format_currency_short)}
                          {Financials.returnRow("", incomeYValues, "EPS", Utils.format_currency_short)}
                          {Financials.returnRow("", incomeYValues, "Gross Margin", Utils.format_percent)}
                          {Financials.returnRow("", incomeYValues, "Profit Margin", Utils.format_percent)}
                        </Table.Body>
                      </Table>
                    </Card.Description>
                  </Card.Content>
                </Card>
              </div>
            </Grid.Column>
            <Grid.Column width={4} className="financials-card-column">
              <div className="chart-wrapper" style={{ width: "100%" }}>
                {ChartUtils.multiAxisChart(
                  "Yearly",
                  "Revenue vs Net Income",
                  ChartUtils.getXyDataFromValues(
                    this.props.stockValues.incomeStmtValues,
                    "Revenue"
                  ),
                  ChartUtils.getXyDataFromValues(
                    this.props.stockValues.incomeStmtValues,
                    "Net Income"
                  ),
                  ChartUtils.getXyDataFromValues(
                    this.props.stockValues.incomeStmtValues,
                    "Profit Margin"
                  ),
                  Utils.format_number,
                  Utils.format_percent
                )}
              </div>
              <div className="chart-wrapper" style={{ width: "100%" }}>
                {ChartUtils.multiAxisChart(
                  "Quarterly",
                  "Revenue vs Net Income",
                  ChartUtils.getXyDataFromValues(
                    this.props.stockValues.quarterlyIncomeStmtValues,
                    "Revenue"
                  ),
                  ChartUtils.getXyDataFromValues(
                    this.props.stockValues.quarterlyIncomeStmtValues,
                    "Net Income"
                  ),
                  ChartUtils.getXyDataFromValues(
                    this.props.stockValues.quarterlyIncomeStmtValues,
                    "Profit Margin"
                  ),
                  Utils.format_number,
                  Utils.format_percent
                )}
              </div>
            </Grid.Column>
            <Grid.Column width={6} className="financials-card-column">
              <div>
                <Card fluid raised className="iv-section-card">
                  <Card.Content className="iv-section-body">
                    <Card.Header textAlign="center" className="iv-section-header">
                      <div className="iv-icon-box"><i className="table icon" /></div>
                      <div>Quarterly Income Statement Values</div>
                    </Card.Header>
                    <Card.Description>
                      {/* Add a div with overflow-x auto */}
                      <div style={{ overflowX: "auto" }}>
                        <Table unstackable compact="very" celled size="small" className="iv-table">
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell className="iv-table-header">Quarter</Table.HeaderCell>
                              {Object.keys(quarterlyIncomeYValues).map((index) => (
                                <Table.HeaderCell className="iv-table-header" key={ChartUtils.getQuarter(quarterlyIncomeYValues[index]["Revenue"].year)}>
                                  {ChartUtils.getQuarter(quarterlyIncomeYValues[index]["Revenue"].year)}
                                </Table.HeaderCell>
                              ))}
                              <Table.HeaderCell className="iv-table-header">Trend</Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {Financials.returnRow("Income", quarterlyIncomeYValues, "Revenue", Utils.format_currency_short)}
                            {Financials.returnRow("", quarterlyIncomeYValues, "Net Income", Utils.format_currency_short)}
                            {Financials.returnRow("", quarterlyIncomeYValues, "EPS", Utils.format_currency_short)}
                            {Financials.returnRow("", quarterlyIncomeYValues, "Gross Margin", Utils.format_percent)}
                            {Financials.returnRow("", quarterlyIncomeYValues, "Profit Margin", Utils.format_percent)}
                          </Table.Body>
                        </Table>
                      </div>
                    </Card.Description>
                  </Card.Content>
                </Card>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    } else if (activeItem === "Balance Sheet") {
      seg = (
        <Grid stackable centered>
          <Grid.Row columns={{ mobile: 1, tablet: 2, computer: 4 }}>
            <Grid.Column width={6} className="financials-card-column financials-chart-column" style={{ width: "100%", alignContent:"right" }}>
              <div className="chart-wrapper" >
                {ChartUtils.stackedBarChart(
                  "Assets vs Liabilities",
                  ChartUtils.getXyDataFromValues(
                    this.props.stockValues.bsStmtValues,
                    "Total Assets"
                  ),
                  ChartUtils.getXyDataFromValues(
                    this.props.stockValues.bsStmtValues,
                    "Total Liabilities"
                  ),
                  Utils.format_number
                )}
              </div>
            </Grid.Column>
            <Grid.Column width={10} className="financials-card-column" > 
              <div>
                <Card fluid raised className="iv-section-card">
                  <Card.Content className="iv-section-body">
                    <Card.Header textAlign="center" className="iv-section-header">
                      <div className="iv-icon-box"><i className="building icon" /></div>
                      <div>Balance Sheet Statement Values</div>
                    </Card.Header>
                    <Card.Description>
                      <div style={{ overflow: "auto", margin: "0 auto" }}>
                        <Table unstackable compact="very" celled size="small" className="iv-table">
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell className="iv-table-header">Year</Table.HeaderCell>
                              {Object.keys(balnceYValues).map((index) => (
                                <Table.HeaderCell className="iv-table-header" key={balnceYValues[index]["Total Assets"].year}>
                                  {balnceYValues[index]["Total Assets"].year.substring(0,4)}
                                </Table.HeaderCell>
                              ))}
                              <Table.HeaderCell className="iv-table-header">Trend</Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {Financials.returnRow("Balance Sheet", balnceYValues, "Total Assets", Utils.format_currency_short)}
                            {Financials.returnRow("", balnceYValues, "Total Liabilities", Utils.format_currency_short)}
                            {Financials.returnRow("", balnceYValues, "Total Stockholders Equity", Utils.format_currency_short)}
                            {Financials.returnRow("", balnceYValues, "Net Debt", Utils.format_currency_short)}
                            {Financials.returnRow("", balnceYValues, "Cash and Short Term Investments", Utils.format_currency_short)}
                          </Table.Body>
                        </Table>
                      </div>
                    </Card.Description>
                  </Card.Content>
                </Card>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    } else if (activeItem === "Cashflow") {
      seg = (
        <Grid stackable centered>
          <Grid.Row columns={{ mobile: 1, tablet: 2, computer: 4 }}>
            <Grid.Column width={6} className="financials-card-column financials-chart-column" style={{  alignContent:"right" }}>
              <div className="chart-stack" >
                {ChartUtils.singleBarChart(
                  "Operating Cashflow",
                  ChartUtils.getXyDataFromValues(
                    this.props.stockValues.cfStmtValues,
                    "Operating Cashflow"
                  ),
                  Utils.format_number
                )}
                {ChartUtils.singleBarChart(
                  "Free Cashflow",
                  ChartUtils.getXyDataFromValues(
                    this.props.stockValues.cfStmtValues,
                    "Free Cashflow"
                  ),
                  Utils.format_number
                )}
              </div>
            </Grid.Column>
            <Grid.Column width={10} className="financials-card-column" >
              <div style={{ width: "95%" }}>
                <Card fluid raised className="iv-section-card">
                  <Card.Content className="iv-section-body">
                    <Card.Header textAlign="center" className="iv-section-header">
                      <div className="iv-icon-box"><i className="dollar sign icon" /></div>
                      <div>Cashflow Statement Values</div>
                    </Card.Header>
                    <Card.Description>
                      <div style={{ margin: "0 auto" }}>
                        <Table unstackable compact="very" celled size="small" className="iv-table">
                          <Table.Header>
                            <Table.Row>
                              <Table.HeaderCell className="iv-table-header">Year</Table.HeaderCell>
                              {Object.keys(cashflowYValues).map((index) => (
                                <Table.HeaderCell className="iv-table-header" key={cashflowYValues[index]["Operating Cashflow"].year}>
                                  {cashflowYValues[index]["Operating Cashflow"].year.substring(0,4)}
                                </Table.HeaderCell>
                              ))}
                              <Table.HeaderCell className="iv-table-header">Trend</Table.HeaderCell>
                            </Table.Row>
                          </Table.Header>
                          <Table.Body>
                            {Financials.returnRow("Cashflow", cashflowYValues, "Operating Cashflow", Utils.format_currency_short)}
                            {Financials.returnRow("Cashflow", cashflowYValues, "Free Cashflow", Utils.format_currency_short)}
                          </Table.Body>
                        </Table>
                      </div>
                    </Card.Description>
                  </Card.Content>
                </Card>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }

    return (
      <div
        className="financials-page"
        style={{
          maxWidth: 1280,
          margin: "0 auto",
          padding: isMobile ? "2rem 0.5rem" : "2rem 1rem",
          boxSizing: "border-box",
        }}
      >
        <Grid stackable centered>
          <Grid.Row columns={{ mobile: 1, tablet: 2, computer: 4 }}>
            <Menu color={color} compact pointing secondary>
              <Menu.Item
                name="Income"
                active={activeItem === "Income"}
                onClick={this.handleItemClick}
              />
              <Menu.Item
                name="Balance Sheet"
                active={activeItem === "Balance Sheet"}
                onClick={this.handleItemClick}
              />
              <Menu.Item
                name="Cashflow"
                active={activeItem === "Cashflow"}
                onClick={this.handleItemClick}
              />
            </Menu>
          </Grid.Row>
          <Grid.Row centered>
            <div style={{ marginTop: "1rem", width: "100%" }}>{seg}</div>
          </Grid.Row>
        </Grid>
      </div>
    );
  }

  static returnRow = (sectionName, values, key, format_function) => {
    return (
      <Table.Row>
        <Table.Cell className="iv-label-cell">{key}</Table.Cell>
        {Object.keys(values).map((index) => {
          const val = values[index][key]?.value ?? null;
          if (val === null || val === undefined) {
            return <Table.Cell key={index}>-</Table.Cell>;
          }
          const negative = val < 0;
          const positive = val > 0;
          return (
            <Table.Cell key={index} className="value-cell" negative={negative} positive={positive}>
              {format_function(val)}
            </Table.Cell>
          );
        })}
        <Table.Cell className="iv-spark-cell">
          {ChartUtils.renderTinyLineChart(ChartUtils.getXyDataFromValues(values, key), "Value")}
        </Table.Cell>
      </Table.Row>
    );
  };

  static renderMetricRow = (label, values, key, format_function) => {
    const data = Object.keys(values).map((index) => values[index][key]?.value ?? null);
    const latest = data.length ? data[data.length - 1] : null;
    const formatted = typeof format_function === "function" ? format_function(latest) : latest;
    const sparkData = ChartUtils.getXyDataFromValues(values, key);
    return (
      <div className="iv-metric-row" key={label + key}>
        <div className="label">{label}</div>
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <div className="value">{formatted}</div>
          <div style={{ width: 90, height: 28 }}>{ChartUtils.renderTinyLineChart(sparkData, "Value")}</div>
        </div>
      </div>
    );
  };
}
